export type MapleOSHeroSliderScreenshot = {
  title: string;
  description: string;
  image: string;
  lightboxImage?: string;
  eyebrow: string;
};

export const mapleOSHeroSliderScreenshots: MapleOSHeroSliderScreenshot[] = [
  {
    title: "Desktop",
    description: "MapleOS desktop, taskbar, systray, and desktop apps.",
    image: "/images/mapleos/hero-slider/mapleos-desktop.png",
    lightboxImage: "/images/mapleos/hero-slider/mapleos-desktop.png",
    eyebrow: "Desktop",
  },
  {
    title: "Maple GIS",
    description: "MapleGIS is a geospatial mapping and analysis tool built for MapleOS.",
    image: "/images/mapleos/hero-slider/maple-gis.png",
    lightboxImage: "/images/mapleos/hero-slider/maple-gis.png",
    eyebrow: "Maps",
  },
  {
    title: "Image Viewer",
    description: "Image viewer app in MapleOS.",
    image: "/images/mapleos/hero-slider/image-viewer.png",
    lightboxImage: "/images/mapleos/hero-slider/image-viewer.png",
    eyebrow: "System",
  },
  {
    title: "Maple Messanger",
    description: "Realtime messaging app in MapleOS.",
    image: "/images/mapleos/hero-slider/messanger.png",
    lightboxImage: "/images/mapleos/hero-slider/messanger.png",
    eyebrow: "Chat",
  },
  {
    title: "AI Center",
    description: "Model controls and intelligence settings built directly into the operating environment.",
    image: "/images/mapleos/hero-slider/ai-center.png",
    lightboxImage: "/images/mapleos/hero-slider/ai-center.png",
    eyebrow: "AI",
  },
  {
    title: "Maple Office",
    description: "Maple Office productivity suite for MapleOS.",
    image: "/images/mapleos/hero-slider/maple-office.png",
    lightboxImage: "/images/mapleos/hero-slider/maple-office.png",
    eyebrow: "Office",
  },
  {
    title: "Paint",
    description: "Classic Paint app for MapleOS.",
    image: "/images/mapleos/hero-slider/paint.png",
    lightboxImage: "/images/mapleos/hero-slider/paint.png",
    eyebrow: "Creative",
  },
  {
    title: "Maple Code Editor",
    description: "Code editor to build your own apps for MapleOS.",
    image: "/images/mapleos/hero-slider/code-editor.png",
    lightboxImage: "/images/mapleos/hero-slider/code-editor.png",
    eyebrow: "Creative",
  },
];